export default __webpack_public_path__ + "static/media/ScrewtheReviewLogo.91be3377.png";